import { useState, useRef, useEffect, useContext } from 'react';
import { useNavigate } from "react-router";
import { toast } from 'react-toastify';

import classes from './styles/Landing.module.css';
import ShopContext from '../../store/shop-context';

import Autocomplete from "react-google-autocomplete";
import { getShop } from '../../api/main';

function Landing(){
  const shopContext = useContext(ShopContext);
  let navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    tel: '',
    address2: '',
    extra: ''
  });
  const [isLoading, setIsLoading] = useState(true);
  const [shopData, setShopData] = useState({});
  const [deliveryData, setDeliveryData] = useState(null);
  const [showStep2, setShowStep2] = useState(false);
  const [showDeliveryNotAvailable, setShowDeliveryNotAvailable] = useState(false);

  const handleClick = () => {
    if( formData.name.length <= 0 || formData.tel.length <= 0)
      toast.error("Por favor completa todos los campos marcados con (*)");
    else {
      shopContext.setDeliveryData({ ...deliveryData, ...formData });
      navigate('/home');
    }
  }

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [id]: value
    }))
  }

  const isLatLngInBounds = (lat, lng, bounds) => {
    return (lat >= bounds.south && lat <= bounds.north &&
            lng >= bounds.west && lng <= bounds.east);
  }

  useEffect(() => {
    if( deliveryData ){
      const isDeliveryAvailable = isLatLngInBounds(deliveryData.location.lat, deliveryData.location.lng, shopData.delivery_area);

      if( !isDeliveryAvailable ){
        setShowStep2(false);
        setShowDeliveryNotAvailable(true);
      } else {
        setShowDeliveryNotAvailable(false);
        setShowStep2(true);
      }
    }
  }, [deliveryData]);

  const handlePlaceChange = async (place) => {
    setDeliveryData({
      formattedAddress: place.formatted_address,
      placeId: place.place_id,
      location: {
        lat: await place.geometry.location.lat(),
        lng: await place.geometry.location.lng(),
      }
    });
  }

  useEffect(() => {

    const get = async () => {
      const ret = await getShop();
      const data = {
        ...ret,
        delivery_area: JSON.parse(ret.delivery_area)
      };
      setShopData(data);
      shopContext.setShop(data);
      setIsLoading(false);
    }

    get();
  }, []);

  return (
    <>
      <div className='row align-items-center justify-content-md-center px-0 mx-0' style={{ height: '60vh' }}>
        <div className='col-md-5'>

          <section className={`${classes.landing}`}>
            
            {isLoading && (
              <div className='text-center'>
                <div className="spinner-border" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            )}

            <p>Ingresa tu direccion para verificar que estas dentro de la zona de entrega.</p>
            <Autocomplete
              style={{ width: '100%' }}
              apiKey={"AIzaSyD20J9WRV9JmKy3ttSrcBxMGvJ6sNmXrSM"}
              options={{
                types: ["geocode"],
                componentRestrictions: { country: "ar" },
              }}
              language='es'
              onPlaceSelected={handlePlaceChange}
            />
          </section>

          {!isLoading && (
            <>
            {showDeliveryNotAvailable && (
              <section className={classes.form}>
                <p>Lo sentimos! La direccion que ingresaste no esta dentro de nuestra area de delivery.</p>
              </section>
            )}

            {showStep2 && (
              <section className={classes.form}>
                <p>Estas dentro de la zona de entrega! Por favor completa los siguientes datos para continuar.</p>
                <div className="mb-3">
                  <label htmlFor="name" className="form-label">Nombre (*)</label>
                  <input type="text" value={formData.name} onChange={handleChange} className="form-control" id="name" aria-describedby="emailHelp" />
                </div>
                <div className="mb-3">
                  <label htmlFor="tel" className="form-label">Telefono (WhatsApp) (*)</label>
                  <input type="number" value={formData.tel} onChange={handleChange} className="form-control" id="tel" aria-describedby="emailHelp" />
                </div>
                <div className="mb-3">
                  <label htmlFor="frmAddress" className="form-label">Direccion (*)</label>
                  <input disabled={true} readOnly={true} value={deliveryData.formattedAddress} type="text" className="form-control" id="frmAddress" aria-describedby="emailHelp" />
                </div>
                <div className="mb-3">
                  <label htmlFor="address2" className="form-label">Piso/Departamento</label>
                  <input type="text" value={formData.address2} onChange={handleChange} className="form-control" id="address2" aria-describedby="emailHelp" />
                </div>
                <button className='btn btn-secondary w-100' onClick={handleClick}>
                  Continuar
                </button>
              </section>
            )}
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default Landing;